import { FormIPSubnetField } from '@ipfabric/ui-components/FormIPSubnetField/FormIPSubnetField';
import type {
  IPSubnetInputValue,
  IPSubnetInputValueOrDraft,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { ipCidrListSchemaZ } from '../../utils/validation';

export const duplicateIpList: FormSnippet<
  DiscoverySettingsObject,
  { duplicateIpList: IPSubnetInputValueOrDraft },
  { duplicateIpList: IPSubnetInputValue }
> = {
  render: ({ form }) => (
    <FormIPSubnetField
      control={form.control}
      name='duplicateIpList'
      label='Allow discovery of duplicate IPs'
      description='List of subnets that allow discovery of duplicate IPs'
      type='cidr'
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.duplicateIpList = {
      ips: model.networks?.whitelist ?? [],
    };
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.networks = {
      ...modelDraft.networks,
      whitelist: transformedValues.duplicateIpList.ips,
    };
  },
  schema: z.object({
    duplicateIpList: ipCidrListSchemaZ,
  }),
};
